<template>   
    <Navbar></Navbar>

    <br/>
    <div v-if="this.vistorias != ''">
        <h4 style="margin: 10px">Vistorias - veículo de placa: {{placa}}</h4>
        <Table :vistorias="vistorias" :email="email"></Table>  
        <p style="margin-left: 10px"><strong>{{numVistorias}}</strong> vistoria(s) encontrada(s)</p>
    </div>
    <router-link to='/Home' style="margin-left: 10px;" title='Voltar para o início'>
        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
        </svg>
    </router-link>

    
</template>


<script>

import APIv3 from '../services/apiv3-endpoints'
import Table from '../components/Table.vue'
import Navbar from '../components/Navbar.vue'


export default {
    name: 'LocalizaPlaca',
    components: {
        Table,
        Navbar
    },

    created: function(){
        this.filtrarPorPlaca()
    },

    data(){
        return{
            vistorias: null,
            email: localStorage.getItem('email'),
            placa: this.$route.query.placa,
            numVistorias: 0
        }
    },

    methods: {
        filtrarPorPlaca(){
            const data = {
                token: localStorage.getItem('token'),
                vistoriador: localStorage.getItem('idUsuario'),
                placa: this.placa
            }

            APIv3.localizarPorPlaca(data.token, data.vistoriador, data.placa)
                .then(response =>{
                    this.vistorias = response.data
                    if(this.vistorias == '') this.showAlert()
                    this.numVistorias = this.vistorias.length
                })
                .catch(err => {    
                    console.log(err)
                })
        },
        showAlert(){
            this.$swal("Placa: " + this.placa,'Não foram encontrados resultados para essa placa.')
            this.$router.push('/Home')
        },
    }
}


</script>

<style>    

</style>